// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1wUeh","messages":"Chat_messages__34jUU","dateDivider":"Chat_dateDivider__3k0ec"};